import { render, staticRenderFns } from "./SynergismTabBar.vue?vue&type=template&id=855f000a&scoped=true&"
import script from "./SynergismTabBar.vue?vue&type=script&lang=js&"
export * from "./SynergismTabBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "855f000a",
  null
  
)

export default component.exports